export class IFilterResoruces {
    type: string = "Todos";
    resource: number = 0;
    rangeDate: IRangeDate;

    constructor(def: any) {
        this.type = def.type || "";
        this.rangeDate = def.rangeDate || new IRangeDate();
        this.resource = def.resource;
    }
}


export class IRangeDate {
    dateInit: string = "";
    dateEnd: string = "";
}

export class ReportResourceFilter {
    preview: boolean = false;
    publishingId: number = 0;
    rangeDate?: IRangeDate;
}